import React, { useState } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import AppointmentListSection from './AppointmentListSection';

const AppointmentList = ({ appointments, onAppointmentCancel }) => {
  const [active, setActive] = useState('upcoming');

  const betweenDates = (attribute, start, end) => (appointment) => (
    moment(appointment[attribute]) >= moment().add(start, 'day').startOf('day')
    && moment(appointment[attribute]) < moment().add(end, 'day').startOf('day')
  );

  const today = appointments.filter(betweenDates('start_date', 0, 1));
  const tomorrow = appointments.filter(betweenDates('start_date', 1, 2));
  const upcoming = appointments.filter(betweenDates('start_date', 2, 9));
  const scheduledToday = appointments.filter(betweenDates('created_at', 0, 1));
  const scheduledYesterday = appointments.filter(betweenDates('created_at', -1, 0));
  const scheduledRecently = appointments.filter(betweenDates('created_at', -9, -2));

  return (
    <div className='appointment-list'>
      <div className='btn-sm btn-group appointment-list-range-filter'>
        <button
          type='button'
          className={`btn${active === 'upcoming' ? ' btn-success' : ' btn-light'}`}
          onClick={() => setActive('upcoming')}
        >
          Upcoming
        </button>
        <button
          type='button'
          className={`btn${active === 'recent' ? ' btn-success' : ' btn-light'}`}
          onClick={() => setActive('recent')}
        >
          Recently Scheduled
        </button>
      </div>

      {
        active === 'upcoming' && (
          <div className='appointment-list-upcoming'>
            <AppointmentListSection
              appointments={today}
              className='appointment-list-section-today'
              title='today'
              dates={moment().format('dddd, MMMM Do, YYYY')}
              emptyMessage='No appointments have been scheduled for today.'
              onAppointmentCancel={onAppointmentCancel}
            />

            <AppointmentListSection
              appointments={tomorrow}
              className='appointment-list-section-tomorrow'
              title='tomorrow'
              dates={moment().add(1, 'day').format('dddd, MMMM Do, YYYY')}
              emptyMessage='No appointments have been scheduled for tomorrow.'
              onAppointmentCancel={onAppointmentCancel}
            />

            <AppointmentListSection
              appointments={upcoming}
              className='appointment-list-section-distant'
              title='upcoming'
              dates={
                `${moment().add(2, 'day').format('dddd, MMMM Do, YYYY')} - `
                + `${moment().add(9, 'day').format('dddd, MMMM Do, YYYY')}`
              }
              emptyMessage='No appointments have been scheduled for the upcoming week.'
              onAppointmentCancel={onAppointmentCancel}
            />
          </div>
        )
      }

      {
        active === 'recent' && (
          <div className='appointment-list-recent'>
            <AppointmentListSection
              appointments={scheduledToday}
              className='appointment-list-section-scheduled-today'
              title='scheduled today'
              dates={moment().format('dddd, MMMM Do, YYYY')}
              emptyMessage='No appointments were scheduled today.'
              onAppointmentCancel={onAppointmentCancel}
            />

            <AppointmentListSection
              appointments={scheduledYesterday}
              className='appointment-list-section-scheduled-yesterday'
              title='scheduled yesterday'
              dates={moment().subtract(1, 'day').format('dddd, MMMM Do, YYYY')}
              emptyMessage='No appointments were scheduled yesterday.'
              onAppointmentCancel={onAppointmentCancel}
            />

            <AppointmentListSection
              appointments={scheduledRecently}
              className='appointment-list-section-scheduled-distant'
              title='scheduled recently'
              dates={
                `${moment().subtract(9, 'day').format('dddd, MMMM Do, YYYY')} - `
                + `${moment().subtract(2, 'day').format('dddd, MMMM Do, YYYY')}`
              }
              emptyMessage='No appointments have been scheduled in the last week.'
              onAppointmentCancel={onAppointmentCancel}
            />
          </div>
        )
      }
    </div>
  );
};

AppointmentList.propTypes = {
  /** A list of appointments */
  appointments: PropTypes.arrayOf(PropTypes.shape({
    created_at: PropTypes.string,
    start_date: PropTypes.string
  })),

  /** Called on an appointment when it is cancelled */
  onAppointmentCancel: PropTypes.func
};

AppointmentList.defaultProps = {
  appointments: [],

  onAppointmentCancel: () => false
};

export default AppointmentList;
